import {
  GET_COMPUTATION_METHOD,
  POST_COMPUTATION_METHOD,
  PUT_COMPUTATION_METHOD,
  DELETE_COMPUTATION_METHOD,
} from "../constants/actionTypes";

const defaultState = {
  computationMethod: [],
};

let data = [];
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_COMPUTATION_METHOD:
        return { ...state, computationMethod: [...action.payload] };
      case POST_COMPUTATION_METHOD:
        return { ...state, computationMethod: [...state.computationMethod, action.payload] };
      case PUT_COMPUTATION_METHOD:
        data = [...state.computationMethod];
        const index = data.findIndex((item) => item.computation_method_id === action.payload.computation_method_id);
        if (index !== -1) data[index] = { ...action.payload };
        return { ...state, computationMethod: [...data] };
      case DELETE_COMPUTATION_METHOD:
        const updatedArr = state.computationMethod.filter((item) => item.computation_method_id !== action.payload);
        return { ...state, computationMethod: [...updatedArr] };
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
